var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profile)?_c('div',{staticClass:"section-preview",class:{
    'height-without-stripe': _vm.$route.meta.is_workspace,
    'height-with-stripe': _vm.$route.meta.is_monitor,
  }},[_c('p',{staticClass:"body-4"},[_vm._v("Selecciona un ticket y comencemos")]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"motion"},[_c('img',{staticStyle:{"cursor":"auto"},attrs:{"src":require("@/app/tickets/assets/img-chat-begin.png")}})])
}]

export { render, staticRenderFns }